import { NgModule } from '@angular/core';
import { ActionBarPortalDirective } from './action-bar-portal.directive';

@NgModule({
  declarations: [ActionBarPortalDirective],
  exports: [ActionBarPortalDirective],
})
export class ActionBarPortalDirectiveModule {}
